import React from "react";
import { RouteProps } from "react-router-dom";
import {
  componentPagesMenu,
  dashboardPagesMenu,
  demoPagesMenu,
  adminDashboardMenu,
  PageHeader,
  authPages,
} from "../menu";

import ComponentsHeader from "../pages/_layout/_headers/ComponentsHeader";
import FormHeader from "../pages/_layout/_headers/FormHeader";
import ChartsHeader from "../pages/_layout/_headers/ChartsHeader";
import ContentHeader from "../pages/_layout/_headers/ContentHeader";
import UtilitiesHeader from "../pages/_layout/_headers/UtilitiesHeader";
import IconHeader from "../pages/_layout/_headers/IconHeader";
import DefaultHeader from "../pages/_layout/_headers/DefaultHeader";

const headers: RouteProps[] = [
  { path: authPages.login.path, element: null },
  { path: demoPagesMenu.signUp.path, element: null },
  { path: demoPagesMenu.page404.path, element: null },
  { path: authPages.otp.path, element: null },
  { path: authPages.setpassword.path, element: null },
  { path: authPages.forgotpassword.path, element: null },
  { path: authPages.payinvoice.path, element: null },
  { path: authPages.PaymentFormEbutton.path, element: null },
  { path: authPages.paymentsuccess.path, element: null },
   { path: authPages.PaymentLinkNotFound.path, element: null },
  { path: authPages.NotFoundRedirect.path, element: null },
  { path: authPages.Page404.path, element: null },
  { path: authPages.CustomerUpdateToken.path, element: null },
  { path: authPages.eButtonService.path, element: null },
  { path: authPages.XMLResponse.path, element: null },
  { path: authPages.CreateEbuttonService.path, element: null },
  { path: authPages.DeleteButtonForm.path, element: null },
  { path: authPages.EditEbuttonService.path, element: null },
  { path: authPages.GetTransactionById.path, element: null },
  { path: authPages.GetTransactionByRefrenceNumber.path, element: null },
  { path: authPages.GetEbuttonTransactions.path, element: null },
  {
    path: dashboardPagesMenu.dashboard.path,
    element: <DefaultHeader name="Dashboard" />,
  },
  {
    path: adminDashboardMenu.merchants.path,
    element: <DefaultHeader name="Merchants" />,
  },
  {
    path: adminDashboardMenu.customers.path,
    element: <DefaultHeader name="Customers" />,
  },
  {
    path: adminDashboardMenu.items.path,
    element: <DefaultHeader name="Items" />,
  },
  {
    path: adminDashboardMenu.invoices.path,
    element: <DefaultHeader name="Invoices" />,
  },
  {
    path: adminDashboardMenu.eButton.path,
    element: <DefaultHeader name="eButtons" />,
  },
  {
    path: adminDashboardMenu.settings.path,
    element: <DefaultHeader name="Settings" />,
  },

    // Merchants Header //
    {
      path: PageHeader.AddMerchant.path,
      element: <DefaultHeader name="Create Merchant" />,
    },
    {
      path: PageHeader.UpdateMerchant.path,
      element: <DefaultHeader name="Update Merchant" />,
    },
    {
      path: PageHeader.UpdateSubMerchant.path,
      element: <DefaultHeader name="Update Sub Merchant" />,
    },
    {
      path: PageHeader.UploadSubMerchants.path,
      element: <DefaultHeader name="Import Sub Merchants" />,
    },

  // Customers Header //
  {
    path: PageHeader.CreateCustomer.path,
    element: <DefaultHeader name="Create Customer" />,
  },
  {
    path: PageHeader.UpdateCustomer.path,
    element: <DefaultHeader name="Update Customer" />,
  },
  {
    path: PageHeader.EmailCustomer.path,
    element: <DefaultHeader name="Email Customer" />,
  },
  {
    path: PageHeader.UploadCustomers.path,
    element: <DefaultHeader name="Import Customers" />,
  },

 // Items Header //
 {
  path: PageHeader.CreateItem.path,
  element: <DefaultHeader name="Create Item" />,
},
{
  path: PageHeader.UpdateItem.path,
  element: <DefaultHeader name="Update Item" />,
},
{
  path: PageHeader.UploadItems.path,
  element: <DefaultHeader name="Import Items" />,
},

//Invoices Header //
{
  path: PageHeader.CreateInvoice.path,
  element: <DefaultHeader name="Create Invoice" />,
},
{
  path: PageHeader.UpdateInvoice.path,
  element: <DefaultHeader name="Update Invoice" />,
},
{
  path: PageHeader.CreateInvoiceItem.path,
  element: <DefaultHeader name="Create Invoice Item" />,
},
{
  path: PageHeader.UpdateInvoiceItem.path,
  element: <DefaultHeader name="Update Invoice Item" />,
},
{
  path: PageHeader.UploadInvoices.path,
  element: <DefaultHeader name="Import Invoices" />,
},
{
  path: PageHeader.Payments.path,
  element: <DefaultHeader name="Invoice Payments" />,
},

 // eButtons Header //
 {
  path: PageHeader.CreateEButton.path,
  element: <DefaultHeader name="Create eButton" />,
},
{
  path: PageHeader.UpdateEbutton.path,
  element: <DefaultHeader name="Update eButton" />,
},
{
  path: PageHeader.GenerateCode.path,
  element: <DefaultHeader name="Generated Code" />,
},

// Users //
{
  path: PageHeader.CreateSuperUser.path,
  element: <DefaultHeader name="Create User" />,
},
{
  path: PageHeader.UpdateSuperUser.path,
  element: <DefaultHeader name="Update User" />,
},

//profile //
{
  path: PageHeader.ProfileCard.path,
  element: <DefaultHeader name="Profile" />,
},

  {
    path: `${componentPagesMenu.components.path}/*`,
    element: <ComponentsHeader />,
  },
  {
    path: `${componentPagesMenu.forms.path}/*`,
    element: <FormHeader />,
  },
  {
    path: `${componentPagesMenu.charts.path}/*`,
    element: <ChartsHeader />,
  },
  {
    path: `${componentPagesMenu.content.path}/*`,
    element: <ContentHeader />,
  },
  {
    path: `${componentPagesMenu.utilities.path}/*`,
    element: <UtilitiesHeader />,
  },
  {
    path: `${componentPagesMenu.icons.path}/*`,
    element: <IconHeader />,
  },
  {
    path: `*`,
    element: <DefaultHeader name="Dashboard" />,
  },
];

export default headers;
